import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IFieldValue, IRegistrationField } from '../../registration-form.service';

export interface DependencyEntry {
  field: IRegistrationField;
  value: IFieldValue;
}

@Component({
  selector: 'display-conditions',
  templateUrl: './display-conditions.component.html',
  styleUrls: ['./display-conditions.component.scss'],
})
export class DisplayConditionsComponent implements OnChanges {
  @Input() field: IRegistrationField | null = null;
  @Input() allFields: IRegistrationField[] = [];

  public dependencies: DependencyEntry[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes.field || changes.allFields) {
      this.dependencies = this.computeDependencies();
    }
  }

  get hasDependencies(): boolean {
    return this.dependencies.length > 0;
  }

  private computeDependencies(): DependencyEntry[] {
    const currentId = this.field ? this.field.option_id : null;
    if (currentId == null) return [];
    const entries: DependencyEntry[] = [];
    for (const f of this.allFields) {
      for (const v of f.values || []) {
        if ((v.questions_to_display || []).indexOf(currentId) >= 0) {
          entries.push({ field: f, value: v });
        }
      }
    }
    return entries;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/registration-form/display-conditions/display-conditions.component.ts